import { createApp } from 'vue';
import { createPinia } from 'pinia';

import '@/styles/app.css';

import App from '@/App.vue';
import router from '@/app/router';
import i18n from '@/app/lang/i18n.js';
import { VueQueryPlugin } from '@tanstack/vue-query';
import Toast from 'vue-toastification';
import FloatingVue from 'floating-vue';

import '@/plugins/dayjs.js';
import Bugsnag from '@/plugins/bugsnag.js';
import vueQueryConfig from '@/plugins/vue-query.js';
import floatingVueConfig from '@/plugins/floating-vue.js';
import toastConfig from '@/plugins/toast.js';

console.time('🕓 Application Loaded');

const app = createApp(App);

app.use(Bugsnag.getPlugin('vue'));
app.use(i18n);
app.use(VueQueryPlugin, vueQueryConfig);
app.use(createPinia());
app.use(FloatingVue, floatingVueConfig);
app.use(Toast, toastConfig);
app.use(router);

app.mount('#app');

console.timeEnd('🕓 Application Loaded');
